import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const COLLAPSED_KEY = 'sbom-sidebar-collapsed';

export default function AppShell({ children, onNavAction }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(COLLAPSED_KEY) === 'true');

  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      localStorage.setItem(COLLAPSED_KEY, String(!prev));
      return !prev;
    });
  };

  return (
    <div className="h-screen flex overflow-hidden bg-paper text-ink">
      <Sidebar collapsed={collapsed} onToggleCollapsed={toggleCollapsed} onAction={onNavAction} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar />
        <main className="flex-1 min-h-0 overflow-hidden">{children}</main>
      </div>
    </div>
  );
}
